import React, { FC } from "react";

interface IAppContentWrapperProps {
  children: React.ReactNode;
  pb?: string;
  noWrap?: boolean;
}

const AppContentWrapper: FC<IAppContentWrapperProps> = ({
  children,
  noWrap,
  pb,
}) => (
  <div className={noWrap ? "" : "content-wrapper"}>
    <div className={`section is-thin ${pb || ""}`}>
      <div className="container is-max-desktop">{children}</div>
    </div>
  </div>
);

export default AppContentWrapper;
